import { WidgetNavigationController } from 'apps/widget/src/components/WidgetNavigationController';
import { useCallback, useContext, useMemo } from 'react';
import { createPortal } from 'react-dom';

import { SupportedMatchInfoHashCategory } from '@vestico/model';

import { Modal } from '@vestico/shared';

import { WidgetRootElementContext } from '../../../components/MainWindow';

export interface CarouselMatchInfoModalProps {
  refElement?: Element;
  showUserMatchInfo: boolean;
  category: SupportedMatchInfoHashCategory | undefined;
  onUserMatchInfoClose: () => void;
}

const CarouselMatchInfoModalInternal = ({ showUserMatchInfo, category, refElement, onUserMatchInfoClose }: CarouselMatchInfoModalProps) => {
  const contextElement = useContext(WidgetRootElementContext);
  const element = useMemo(() => refElement ?? contextElement, [contextElement, refElement]);

  const onSetCurrentStep = useCallback(() => onUserMatchInfoClose(), [onUserMatchInfoClose]);
  const modal = (
    <Modal open={showUserMatchInfo} onClose={onUserMatchInfoClose}>
      <WidgetNavigationController
        category={category}
        showPrivacyOnMobile
        showBackButtonAtLastStep
        showCancelButtonAtFirstStep
        didPressFirstStepCancelButton={onUserMatchInfoClose}
        onFinishUserMatchInfoForm={onSetCurrentStep}
      />
    </Modal>
  );

  if (!element) {
    return null;
  }

  const portal = createPortal(modal, element);
  return portal;
};

export const CarouselMatchInfoModal = (props: CarouselMatchInfoModalProps) => {
  return (
    /* eslint-disable-next-line react/jsx-props-no-spreading */
    <CarouselMatchInfoModalInternal {...props} />
  );
};
